import React from 'react';
import Title from '../shared/Title';
import { DISCOUNTED_PENSION_PLAN_PRICE, PENSION_PLAN_PRICE } from '../../constants/constants';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import descuento from '../../images/png/descuento.png';
import Text from '../shared/Text';
import { breakpoints, flexRow } from '../../constants/styles';
import { layout } from 'styled-system';
import PensionPlanCTA from './PensionPlanCTA';

export const StyledFirstButton = css`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 40px;
  padding: 0px 20px;
`;

const StyledNewPrice = css`
  font-size: 2.5rem;
  line-height: 1;
`;

const StyledDiscountedPrice = css`
  font-size: 1.8rem;
  line-height: 1;
  margin-right: 10px;
  text-decoration: line-through;
  -webkit-text-decoration-color: #f00a0a;
  text-decoration-color: #f00a0a;
`;

const StyledResultImageExamplePlan = styled.img`
  align-self: flex-end;
  max-width: 220px;
  height: auto;
  align-self: center;
  margin-bottom: 20px;
  margin-top: 50px;
  ${breakpoints.tabletLandscape} {
    margin-top: 80px;
  }
  ${layout}
`;

export const StyledButtonA = styled.a`
  width: 250px;
  margin-bottom: 10px;
  text-decoration: none;
`;

export const StyledLink = styled(Link)`
  width: 250px;
  text-decoration: none;
`;

const StyledDiscountContainer = styled.div`
  ${flexRow}
  justify-content: center;
  align-items: center;
  margin: 20px 0px;
`;

const Discount = styled.img.attrs({
  src: descuento,
})`
  position: relative;
  top: -20px;
  right: -15px;
  height: 40px;
  width: 40px;
`;

export default function PensionPlanShowoff({ referralId, withDiscount, maxWidth, pageOrigin }) {
  return (
    <>
      <StyledResultImageExamplePlan
        src={`https://s3.us-east-2.amazonaws.com/finauta/products/pdf-preview.png`}
        maxWidth={maxWidth}
      />
      <Title level={3} style={{ marginBottom: '20px' }}>
        Plan de pensión
      </Title>
      <StyledDiscountContainer>
        {withDiscount && (
          <>
            <Discount />
            <Text type="body2" styles={StyledDiscountedPrice}>
              ${PENSION_PLAN_PRICE}
            </Text>
            <Text type="body2" styles={StyledNewPrice} medium>
              ${DISCOUNTED_PENSION_PLAN_PRICE}
            </Text>
          </>
        )}
      </StyledDiscountContainer>
      <PensionPlanCTA referralId={referralId} withDiscount={withDiscount} origin={pageOrigin} />
    </>
  );
}
